<template>
  <div>
<div v-if="!subscribedToService">
  <v-card flat color="white">
    <v-card-text>
      <span class="grey--text subtitle font-weight-bold">
        Oops, it looks like the details for OneSignal notifications haven't yet been added. Please navigate to the 'Integrations' table, and add your OneSignal API details.

      </span>
    </v-card-text>

  </v-card>
</div>
<div v-else>
   <v-snackbar :top="y === 'top'" v-model="snackbar" color="success">
      {{text}} <v-btn class="white--text" flat @click="snackbar = false">X</v-btn>
    </v-snackbar>
     <v-snackbar :top="y === 'top'" v-model="errorSnackbar" color="red">
      {{errorText}} <v-btn class="white--text" flat @click="errorSnackbar = false">X</v-btn>
    </v-snackbar>
    <v-toolbar flat color="white">
      <v-spacer></v-spacer>
      <v-btn round color="primary" class="white--test" @click="newNotification()">New Notification</v-btn>
    </v-toolbar>
    <v-data-table :rows-per-page-items="[25, 50, 100]" :pagination.sync="pagination" :items="notifications" :headers="headers">
      <template v-slot:items="props">
        <!-- <td class="text-xs-center">{{formatDate(props.item.queued_at*1000)}}</td> -->
        <td class="text-xs-center">{{formatDate(props.item.completed_at*1000)}}</td>
        <td class="text-xs-center">{{props.item.successful}}</td>
        <td class="text-xs-center">{{props.item.failed}}</td>
        <td class="text-xs-center">{{props.item.errored}}</td>
        <td class="text-xs-center">{{props.item.remaining}}</td>
        <td class="text-xs-center">{{props.item.headings.en}}</td>
        <td class="text-xs-center">{{props.item.contents.en}}</td>
      </template>
    </v-data-table>
    <v-dialog v-model="newNotificationModal" max-width="600px" persistent>
      <v-card flat color="white">
        <v-toolbar color="primary">
          <h3 class="title white--text">New Notification</h3>
          <v-spacer></v-spacer>
          <v-btn flat color="white" @click="newNotificationModal = false, item={}">X</v-btn>
        </v-toolbar>
        <v-card-text>
          <v-text-field v-model="item.title" label="Title"></v-text-field>
          <v-text-field v-model="item.message" label="Message"></v-text-field>
          <v-checkbox v-model="allNetworks" label="Send to all Networks"></v-checkbox>
          <v-autocomplete
            v-if="!allNetworks"
            :items="networks"
            v-model="item.networks"
            chips
            multiple
            deletable-chips
            clearable
            item-text="name"
            item-value="id"
            label="Select Networks"
          ></v-autocomplete>
          
               <v-checkbox v-model="allCustomers" label="Send to all ISPs"></v-checkbox>
                 
          <v-autocomplete
            v-if="!allCustomers"
            :items="customers"
            v-model="item.customers"
            chips
            multiple
            deletable-chips
            clearable
            item-text="name"
            item-value="id"
            label="Select ISPs"
          ></v-autocomplete>
                   
          <v-checkbox v-model="allContactTypes" label="Send to all Contact Types"></v-checkbox>
          <v-autocomplete
            v-if="!allContactTypes"
            chips
            deletable-chips
            multiple
            clearable
            :items="contactTypes"
            item-text="name"
            item-value="id"
            v-model="item.contactTypes"
            label="Contact Types"
          ></v-autocomplete>
        </v-card-text>
        <v-card-actions>
          <v-layout justify-center>
            <v-btn
              round
              color="primary"
              class="white--text"
              @click="viewContacts(item)"
            >Preview Contacts</v-btn>
            <v-btn
              round
              color="primary"
              class="white--text"
              @click="sendNotification(item)"
            >Send Notification</v-btn>
            <v-btn
              round
              color="primary"
              class="white--text"
              @click="sendTestNotification(item)"
            >Get Test Notification</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="previewContactsModal" max-width="600px" persistent>
      <v-card>
        <v-toolbar flat color="primary">
          <h3 class="title white--text">Preview Contacts</h3>
          <v-spacer></v-spacer>
          <v-btn flat color="white" @click="previewContactsModal = false">X</v-btn>
        </v-toolbar>
        <v-toolbar flat color="white">
          <v-spacer></v-spacer>
          <v-text-field label="Search" v-model="search" clearable></v-text-field>
        </v-toolbar>
        <v-card-text>
          <v-data-table :search="search" :items="item.allContacts" :headers="contactHeaders">
            <template v-slot:items="props">
              <td class="text-xs-center">{{props.item.contact.name}}</td>
              <td class="text-xs-center">{{props.item.contact.surname}}</td>
              <td class="text-xs-center">{{props.item.location.locationDescription}}</td>
              <td class="text-xs-center">{{props.item.location.locationNetwork.name}}</td>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</div>

    
</template>
<script>
import Api from "@/services/Api";
import dateformat from "dateformat";

export default {
  data() {
    return {
      customers:[],
      allCustomers: true,
      item: {
        title: "",
        message: ""
      },
      search: '',
      subscribedToService: false,
      contactTypes: [],
      networks: [],
      snackbar: false,
      text: '',
      errorSnackbar: false,
      errorText: '',
      allNetworks: true,
      allContactTypes: true,
      newNotificationModal: false,
      notifications: [],
      previewContactsModal: false,
      y: "top",
      pagination: {
        descending: true,
        sortBy: "completed_at"
      },
      contactHeaders: [
        {
          text: "Name",
          align: "center",
          value: "contact.name"
        },
        {
          text: "Surname",
          align: "center",
          value: "contact.surname"
        },
        {
          text: "Unit",
          align: "center",
          value: "location.locationDescription"
        },
        {
          text: "Network",
          align: "center",
          value: "location.locationNetwork.name"
        }
      ],
      headers: [
        // {
        //   text: "Created",
        //   align: "center",
        //   value: "queued_at"
        // },
        {
          text: "Sent",
          align: "center",
          value: "completed_at"
        },
        {
          text: "Successful",
          align: "center",
          value: "successful"
        },
        {
          text: "Unsubscribed",
          align: "center",
          value: "failed"
        },
        {
          text: "Failed",
          align: "center",
          value: "errored"
        },
        {
          text: "Remaining",
          align: "center",
          value: "remaining"
        },
        {
          text: "Title",
          align: "center",
          value: "headings.en"
        },
        {
          text: "Message",
          align: "center",
          value: "contents.en"
        }
      ]
    };
  },
  async created() {
    this.subscribedToService = await this.checkSubscription()
    if(this.subscribedToService){
    this.getNotifications();
    this.getNetworks();
    this.fetchCustomers()
    this.getContactTypes();
    }
   
  },
  methods: {
    fetchCustomers() {
      Api()
        .get("/customer/organisation/basic/providers")
        .then(response => {
          this.customers = response.data;
        });
    },
    async checkSubscription(){
      let result = false
      await Api().get('/integrations/byName/OneSignal: Customer App')
      .then(response=>{
        if(response.data.id){
          result = true
        }
      })
      return result
    },
    newNotification() {
      this.item = {
        title: "",
        message: "",
        networks: [],
        contacts: [],
        customers:[],
        contactTypes: []
      };
      this.newNotificationModal = true;
    },
    formatDate(date) {
      if (date !== null) {
        return dateformat(date, "yyyy-mm-dd HH:MM");
      } else {
        null;
      }
    },
    async getContactTypes() {
      await Api()
        .get("/contactTypes")
        .then(response => {
          this.contactTypes = response.data;
        });
    },
    async getNetworks() {
      await Api()
        .get("/locationNetworks/simple/active")
        .then(response => {
          this.networks = response.data;
        });
    },
    async getNotifications() {
      await Api()
        .get("/notifications/onesignal/all/OneSignal: Customer App")
        .then(response => {
          this.notifications = response.data.notifications;
        });
    },
    async viewContacts(item) {
      this.item.allContacts = await this.previewContacts(item);
      this.previewContactsModal = true;
    },
    async sendNotification(item) {
      this.item.allContacts = await this.previewContacts(item);
      this.item.contacts = await this.previewContacts(item);
      this.item.name = 'OneSignal: Customer App'
      await this.createNotification(this.item);
    },

    async sendTestNotification(){
      this.item.contacts = [this.$store.state.user.id.toString()]
      this.item.name = 'OneSignal: Customer App'
     await Api()
          .post("/notifications/onesignal/createNotification", this.item)
          .then(response => {
            if(response.data.body.recipients >0){
               this.snackbar = true
              this.text = "Successfully sent out your test notification!"
            } else {
              this.errorSnackbar = true
              this.errorText = "You have no devices subscribed to this service."
            }
          })
    },

    async previewContacts(item) {
      let contacts = [];
      if (this.allContactTypes) {
        this.item.contactTypes = this.contactTypes.map(x => x.id);
      }
      if (this.allNetworks) {
        this.item.networks = this.networks.map(x => x.id);
      }
      if (this.allCustomers) {
        this.item.customers = this.customers.map(x => x.id);
      }
      await Api()
        .post("/locationContacts/bulkNotification", item)
        .then(response => {
          this.item.contacts = response.data.map(x => x.contactId.toString());
          contacts = response.data;
        });
      return contacts;
    },
    async createNotification(item) {
      item.name = 'customerApp'
      confirm("Are you sure you want to send out this notification?") &&
        (await Api()
          .post("/notifications/onesignal/createNotification", item)
          .then(response => {
            if(response.data.body.recipients >0){
               this.snackbar = true
              this.text = "Successfully sent out notifications to " + response.data.body.recipients + " contacts!"
            } else {
              this.errorSnackbar = true
              this.errorText = "None of the selected contacts are subscribed to notifications."
            }
            this.getNotifications();
            this.allContactTypes = true;
            this.allNetworks = true;
            this.newNotificationModal = false;
            this.item = {};
          }));
    }
  }
};
</script>